import React from "react";
import { getICMSList, createICMSTemplate, updateICMSTemplate } from "../../../../api/products";
import LoadingContainer from "../../../../_components/LoadingContainer";
import LoadingInput from "../../../../_components/LoadingInput";
import CurrencyInput from "react-currency-input"
import Button from "../../../../_components/Button";
import Modal from "../../../../_components/Modal";
import Text from "../../../../_components/Text";
import TableData from "../../../../_components/TableData";
import AppContext from "../../../AppViews/context";
import { CSOSN_DATA, ICMS_CST } from "./data"
import { showSnackBar } from "../../../../utils";

export default props => {
    const context = React.useContext(AppContext)

    const [loading, setLoading] = React.useState(false)
    const [data, setData] = React.useState([])
    const [icms, setICMS] = React.useState({})

    function onHide() { }
    function setItem(item) { }
    function onChange(e) { }
    function onSave() {
        setTimeout(() => window.location.reload(), 1500)
    }
    function init() {
        setLoading(true)
        getICMSList()
            .then(resp => {
                resp = resp.map(icms => {
                    return {
                        ...icms,
                        "orig": icms.orig == 0 ? "0= Nacional" :
                                icms.orig == 1 ? "1= Estrangeira" :
                                icms.orig == 2 ? "2= Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7":
                                icms.orig == 3 ? "3= Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% (quarenta por cento) e inferior ou igual a 70% (setenta por cento)":
                                icms.orig == 5 ? "5= Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40% (quarenta por cento)":
                                icms.orig == 6 ? "6= Estrangeira, importação direta, sem similar nacional, constante em lista de resolução do conselho de ministros":
                                icms.orig == 7 ? "7= Estrangeira, adquirida no mercado interno, sem similar nacional, constante em lista de resolução da CAMEX":
                                icms.orig == 8 ? "8= Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%" : "",
                        "edit": <Button onClick={() => setICMS(icms)} as="text"><i className="fas fa-edit"></i></Button>
                    }
                })
                setData(resp)
            })
            .finally(() => {
                setLoading(false)
            })
    }
    React.useEffect(init, [])
    const key = context.currentBranch.crt == 3 ? "CST" : "CSOSN"
    const value = context.currentBranch.crt == 3 ? "cst" : "csosn"
    return <div className="container">
        <div className="row">
            <div className="col-12 py-3">
                <Text className="text-center" as="h1">
                    Modelos de ICMS
                </Text>
                <div className="d-flex justify-content-center my-3">
                    <Template
                        showDisclaimer={data.length === 0}
                        onSave={onSave}
                        data={icms} />
                </div>
                {
                    data.length > 0
                        ? <LoadingContainer loading={loading}>
                            <TableData
                                data={data}
                                tHead={["Nome", "Origem da Mercadoria", key, "Alíquota (%)", "Ações"]}
                                tBodyKeys={["name", "orig", value, "p_icms", "edit"]}
                            />
                        </LoadingContainer>
                        : <React.Fragment />
                }
            </div>
        </div>
    </div>
}

export function Template(props) {
    const context = React.useContext(AppContext)

    const [show, setShow] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [cst, setCST] = React.useState([])
    const [template, setTemplateData] = React.useState({})
    const key = context.currentBranch.crt === 3 ? "CST" : "CSOSN"
    const value = context.currentBranch.crt === 3 ? "cst" : "csosn"

    function onChange({ target }) {
        const { name: key, value } = target
        setTemplateData({
            ...template,
            [key]: value
        })
    }
    function onHide() {
        setTemplateData({})
        setShow(false)
    }
    function onSubmit() {

        if (!template.name && !template.orig && !template.csosn) {
            return
        }

        if (template.orig === undefined) {
            showSnackBar("Selecione a origem da mercadoria")
            try { document.querySelector('[name="orig"]').focus() } catch (error) { }
            return
        }
        if (!template[value] === undefined) {
            showSnackBar(`Selecione o ${key}`)
            try { document.querySelector(`[name="${value}"]`).focus() } catch (error) { }
            return
        }

        if (context.currentBranch.crt != 3 && template.csosn === undefined ||
            context.currentBranch.crt != 3 && template.csosn == '' ||
            context.currentBranch.crt == 3 && template.cst == undefined ||
            context.currentBranch.crt == 3 && template.cst == ''

        ) {
            showSnackBar(`Selecione um ${context.currentBranch.crt == 3 ? 'cst' : 'csosn'} válido`)
            try { document.querySelector('[name="csosn"]').focus() } catch (error) { }
            return
        }

        const request = template.id ? updateICMSTemplate : createICMSTemplate

        setLoading(true)

        request(template)
            .then(icms => {
                showSnackBar("ICMS Salvo", "info")
                if (!props.onSave) {
                    setTimeout(() => window.location.reload(), 1500)
                } else {
                    props.onSave(icms)
                }
            })
            .finally(() => {
                setTimeout(() => {
                    setLoading(false)
                    if (props.onClear) {
                        setShow(false)
                        setTemplateData({})
                    }
                }, 2000)
            })
    }
    function automate() {
        setTemplateData({
            name: "SIMPLES NACIONAL",
            orig: "0",
            csosn: "102"
        })
    }
    function edit() {
        if (props.data.id) {
            setTemplateData({ ...props.data, p_icms: props.data.p_icms || 0 })
            setShow(true)
        }
    }
    React.useEffect(edit, [props.data])
    function init() {
        setCST(context.currentBranch.crt == 3 ? ICMS_CST : CSOSN_DATA)
    }
    React.useEffect(init, [])
    return <div>
        <Button
            as="text"
            onClick={() => setShow(true)} >
            Criar novo modelo
        </Button>
        <Modal show={show} title="Cadastrar modelo de ICMS" onHide={onHide}>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        {
                            props.showDisclaimer
                                ?
                                <div className="py-3">
                                    <Text>
                                        Clique <Button onClick={automate} as="text">aqui</Button> criar a configuração padrão de ICMS
                                    </Text>
                                    <Text>
                                        Importante: esse tipo de configuração padrão deve ser consultado e confirmado, de preferência, pela contabilidade da sua empresa.
                                    </Text>
                                </div>
                                : <React.Fragment />
                        }
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Nome/descrição do modelo
                                </Text>
                            </div>
                            <LoadingInput
                                loading={loading}
                                required
                                name="name"
                                onChange={onChange}
                                value={template.name} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Origem da mercadoria
                                </Text>
                            </div>
                            <LoadingInput
                                loading={loading}
                                name="orig"
                                required
                                onChange={onChange}
                                as="select">
                                <option selected disabled>
                                    Selecione a origem
                                </option>
                                <option selected={template.orig == '0'} value="0">0= Nacional</option>
                                <option selected={template.orig == '1'} value="1">1= Estrangeira</option>
                                <option selected={template.orig == '2'} value="2">2= Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7</option>
                                <option selected={template.orig == '3'} value="3">3= Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% (quarenta por cento) e inferior ou igual a 70% (setenta por cento)</option>
                                <option selected={template.orig == '4'} value="4">4= Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos (PPB) de que tratam o Decreto-Lei nº 288/1967, e as Leis nºs 8.248/1991, 8.387/1991, 10.176/2001 e 11.484/2007.</option>
                                <option selected={template.orig == '5'} value="5">5= Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40% (quarenta por cento)</option>
                                <option selected={template.orig == '6'} value="6">6= Estrangeira, importação direta, sem similar nacional, constante em lista de resolução do conselho de ministros</option>
                                <option selected={template.orig == '7'} value="7">7= Estrangeira, adquirida no mercado interno, sem similar nacional, constante em lista de resolução da CAMEX</option>
                                <option selected={template.orig == '8'} value="8">8= Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%</option>
                            </LoadingInput>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Selecione o {context.currentBranch.crt == 3 ? "CST" : "CSOSN"}
                                </Text>
                            </div>
                            <LoadingInput
                                loading={loading}
                                name={context.currentBranch.crt == 3 ? "cst" : "csosn"}
                                onChange={onChange}
                                as="select">
                                <option>
                                    Selecione o {context.currentBranch.crt == 3 ? "CST" : "CSOSN"}
                                </option>
                                {
                                    (context.currentBranch.crt == 3 ? ICMS_CST : CSOSN_DATA).map((item, idx) => {
                                        return <option
                                            selected={template[value] == item.value}
                                            key={`icms-list-${item.value}${idx}`}
                                            value={item.value}>{item.label}</option>
                                    })
                                }
                            </LoadingInput>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Alíquota do ICMS
                                </Text>
                            </div>
                            <CurrencyInput
                                disabled={loading}
                                required={true}
                                name="p_icms"
                                value={template.p_icms}
                                onChange={(e, value, b) => onChange({ target: { name: "p_icms", value } })}
                                suffix=" %"
                                className="form-control" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex justify-content-start">
                            <Button
                                id="create-icms-template-ijkl-xpto"
                                onClick={onSubmit}
                                as="text"
                                disabled={loading} >
                                Salvar modelo de ICMS
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </div>

}


// WEBPACK FOOTER //
// ./src/views/Fiscal/Taxes/ICMS/index.jsx